import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

interface AnimatronicDiscussionProps {
  animatronicId: string;
  topicId: string;
  commentCount?: number;
}

const AnimatronicDiscussion: React.FC<AnimatronicDiscussionProps> = ({
  animatronicId,
  topicId,
  commentCount = 0
}) => {
  return (
    <div className="mt-8 border-t border-gray-800 pt-8">
      <Link
        to={`/community/comments/${topicId}`}
        className="inline-flex items-center px-6 py-3 bg-brand hover:bg-brand-dark text-white rounded-lg transition-colors"
      >
        <MessageCircle className="w-5 h-5 mr-2" />
        Join the Discussion
        {commentCount > 0 && (
          <span className="ml-2 px-2 py-0.5 bg-white/20 rounded-full text-sm">
            {commentCount} comments
          </span>
        )}
      </Link>
    </div>
  );
}

export default AnimatronicDiscussion;